module.exports = __webpack_public_path__ + "static/media/icon-right-dark-grey.7f50d37d.svg";